/* RESPONSIBLE TEAM: team-inbox-management */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, { attr } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { computed } from '@ember/object';

const Validations = buildValidations({
  capacityLimit: {
    validators: [
      validator('number', {
        allowString: true,
        gte: 1,
        lt: 1_000_000,
      }),
    ],
  },
  ticketAssignmentLimit: {
    validators: [
      validator('number', {
        allowNone: true,
        allowString: true,
        gte: 1,
        lt: 1_000_000,
        disabled: computed(
          'model.{ticketAssignmentLimitEnabled,ticketsAssignmentDisabled}',
          function () {
            return !this.model.ticketAssignmentLimitEnabled || this.model.ticketsAssignmentDisabled;
          },
        ),
      }),
    ],
  },
});

export default class AppConversationCapacityLimit extends Model.extend(Validations) {
  @attr('string') declare appId: string;
  @attr('number') declare capacityLimit: number;
  @attr('array') declare sortingCriteria: any[];
  @attr('boolean') declare pullConversationEnabled: boolean;
  @attr('boolean') declare ticketsAssignmentDisabled: boolean;
  @attr('number') declare ticketAssignmentLimit: number;
  @attr('boolean') declare ticketAssignmentLimitEnabled: boolean;

  get usesCustomTicketAssignmentLimit() {
    return this.ticketAssignmentLimitEnabled && !this.ticketsAssignmentDisabled;
  }
}
